export default __webpack_public_path__ + "static/splash-562fa55d38f8943f64528224c914baf2.png";